import { Link, useLocation } from 'react-router-dom'
import { X, FileText, Image, QrCode, Type, Palette, Clock, Ruler } from 'lucide-react'
import { useState, useEffect } from 'react'

const toolCategories = [
  { id: 'image', name: 'Image Tools', icon: Image, color: 'text-blue-600', bgColor: 'bg-blue-50' },
  { id: 'qr', name: 'QR & Barcode', icon: QrCode, color: 'text-green-600', bgColor: 'bg-green-50' },
  { id: 'text', name: 'Text Tools', icon: Type, color: 'text-purple-600', bgColor: 'bg-purple-50' },
  { id: 'color', name: 'Color Tools', icon: Palette, color: 'text-pink-600', bgColor: 'bg-pink-50' },
  { id: 'time', name: 'Time Tools', icon: Clock, color: 'text-orange-600', bgColor: 'bg-orange-50' },
  { id: 'unit', name: 'Unit Converter', icon: Ruler, color: 'text-indigo-600', bgColor: 'bg-indigo-50' },
  { id: 'pdf', name: 'PDF Tools', icon: FileText, color: 'text-red-600', bgColor: 'bg-red-50' },
]

export default function Sidebar({ isOpen, onClose }) {
  const location = useLocation()

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed left-0 top-16 h-[calc(100vh-4rem)] w-64 bg-white border-r border-gray-200 z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        <div className="p-4">
          <div className="flex items-center justify-between mb-4 lg:hidden">
            <h2 className="text-lg font-semibold text-gray-900">Tools</h2>
            <button
              onClick={onClose}
              className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>
          </div>

          <nav className="space-y-1">
            {toolCategories.map((category) => {
              const Icon = category.icon
              const isActive = location.pathname === `/tools/${category.id}`
              
              return (
                <Link
                  key={category.id}
                  to={`/tools/${category.id}`}
                  onClick={onClose}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive
                      ? 'bg-primary-50 text-primary-700 font-medium'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <div className={`w-8 h-8 ${category.bgColor} rounded-lg flex items-center justify-center`}>
                    <Icon className={`w-4 h-4 ${category.color}`} />
                  </div>
                  <span>{category.name}</span>
                </Link>
              )
            })}
          </nav>
        </div>
      </aside>
    </>
  )
}

